export const glyphData = [
    // ['// glyph_name',ps_name',sort_final],
    // ['.notdef', '.notdef', 0],
    ['fluteChart', '\uE000', 1],
    ['fluteCFoot', '\uE001', 2],
    ['fluteBFoot', '\uE002', 3],
    ['fluteRHCSharpTrill', '\uE003', 4],
    ['fluteOpenHoleSystem', '\uE004', 5],
    ['fluteKingmaSystem', '\uE005', 6],
    ['fluteLHThumbBFlatClosed', '\uE006', 7],
    ['fluteLHThumbBClosed', '\uE007', 8],
    ['fluteLH1stFingerClosed', '\uE008', 9],
    ['fluteLH2ndFingerClosed', '\uE009', 10],
    ['fluteLH3rdFingerClosed', '\uE00A', 11],
    ['fluteLHGSharpClosed', '\uE00B', 12],
    ['fluteRHCSharpTrillClosed', '\uE00C', 13],
    ['fluteRHBFlatTrillClosed', '\uE00D', 14],
    ['fluteRH1stFingerClosed', '\uE00E', 15],
    ['fluteRHDTrillClosed', '\uE00F', 16],
    ['fluteRH2ndFingerClosed', '\uE010', 17],
    ['fluteRHDSharpTrillClosed', '\uE011', 18],
    ['fluteRH3rdFingerClosed', '\uE012', 19],
    ['fluteRHEFlatPaddleClosed', '\uE013', 20],
    ['fluteRHLowCSharpClosed', '\uE014', 21],
    ['fluteRHLowCClosed', '\uE015', 22],
    ['fluteRHLowBClosed', '\uE016', 23],
    ['fluteRHGizmoClosed', '\uE017', 24],
    ['fluteKingmaCUpLeverClosed', '\uE018', 25],
    ['fluteKingmaAuxCSharpTrillClosed', '\uE019', 26],
    ['fluteKingmaBbUpLeverClosed', '\uE01A', 27],
    ['fluteKingmaBUpLeverClosed', '\uE01B', 28],
    ['fluteKingmaGUpLeverClosed', '\uE01C', 29],
    ['fluteKingmaFSharpBarClosed', '\uE01D', 30],
    ['fluteKingmaDUpLeverClosed', '\uE01E', 31],
    ['fluteLH2ndFingerRingOnly', '\uE01F', 32],
    ['fluteLH3rdFingerRingOnly', '\uE020', 33],
    ['fluteRH1stFingerRingOnly', '\uE021', 34],
    ['fluteRH2ndFingerRingOnly', '\uE022', 35],
    ['fluteRH3rdFingerRingOnly', '\uE023', 36],
    ['fluteLH1stFingerHalfClosedLeft', '\uE024', 37],
    ['fluteLH2ndFingerHalfClosedLeft', '\uE025', 38],
    ['fluteLH3rdFingerHalfClosedLeft', '\uE026', 39],
    ['fluteRH1stFingerHalfClosedLeft', '\uE027', 40],
    ['fluteRH2ndFingerHalfClosedLeft', '\uE028', 41],
    ['fluteRH3rdFingerHalfClosedLeft', '\uE029', 42],
    ['fluteLH1stFingerHalfClosedRight', '\uE02A', 43],
    ['fluteLH2ndFingerHalfClosedRight', '\uE02B', 44],
    ['fluteLH3rdFingerHalfClosedRight', '\uE02C', 45],
    ['fluteRH1stFingerHalfClosedRight', '\uE02D', 46],
    ['fluteRH2ndFingerHalfClosedRight', '\uE02E', 47],
    ['fluteRH3rdFingerHalfClosedRight', '\uE02F', 48],
    ['fluteLH1stFingerQuarterClosedLeft', '\uE030', 49],
    ['fluteLH2ndFingerQuarterClosedLeft', '\uE031', 50],
    ['fluteLH3rdFingerQuarterClosedLeft', '\uE032', 51],
    ['fluteRH1stFingerQuarterClosedLeft', '\uE033', 52],
    ['fluteRH2ndFingerQuarterClosedLeft', '\uE034', 53],
    ['fluteRH3rdFingerQuarterClosedLeft', '\uE035', 54],
    ['fluteLH1stFingerQuarterClosedRight', '\uE036', 55],
    ['fluteLH2ndFingerQuarterClosedRight', '\uE037', 56],
    ['fluteLH3rdFingerQuarterClosedRight', '\uE038', 57],
    ['fluteRH1stFingerQuarterClosedRight', '\uE039', 58],
    ['fluteRH2ndFingerQuarterClosedRight', '\uE03A', 59],
    ['fluteRH3rdFingerQuarterClosedRight', '\uE03B', 60],
    ['fluteLHThumbBFlatTrill', '\uE03C', 61],
    ['fluteLHThumbBTrill', '\uE03D', 62],
    ['fluteLH1stFingerTrill', '\uE03E', 63],
    ['fluteLH2ndFingerTrill', '\uE03F', 64],
    ['fluteLH3rdFingerTrill', '\uE040', 65],
    ['fluteLHGSharpTrill', '\uE041', 66],
    ['fluteRHCSharpTrillTrill', '\uE042', 67],
    ['fluteRHBFlatTrillTrill', '\uE043', 68],
    ['fluteRH1stFingerTrill', '\uE044', 69],
    ['fluteRHDTrillTrill', '\uE045', 70],
    ['fluteRH2ndFingerTrill', '\uE046', 71],
    ['fluteRHDSharpTrillTrill', '\uE047', 72],
    ['fluteRH3rdFingerTrill', '\uE048', 73],
    ['fluteRHEFlatPaddleTrill', '\uE049', 74],
    ['fluteRHLowCSharpTrill', '\uE04A', 75],
    ['fluteRHLowCTrill', '\uE04B', 76],
    ['fluteRHLowBTrill', '\uE04C', 77],
    ['fluteRHGizmoTrill', '\uE04D', 78],
    ['fluteKingmaCUpLeverTrill', '\uE04E', 79],
    ['fluteKingmaAuxCSharpTrillTrill', '\uE04F', 80],
    ['fluteKingmaBbUpLeverTrill', '\uE050', 81],
    ['fluteKingmaBUpLeverTrill', '\uE051', 82],
    ['fluteKingmaGUpLeverTrill', '\uE052', 83],
    ['fluteKingmaFSharpBarTrill', '\uE053', 84],
    ['fluteKingmaDUpLeverTrill', '\uE054', 85],
    ['clarinetChart', '\uE0A0', 86],
    ['clarinetBassEFlatOpen', '\uE0A1', 87],
    ['clarinetRegisterClosed', '\uE0A2', 88],
    ['clarinetLHThumbClosed', '\uE0A3', 89],
    ['clarinetLHAClosed', '\uE0A4', 90],
    ['clarinetLHGSharpClosed', '\uE0A5', 91],
    ['clarinetLH1stFingerClosed', '\uE0A6', 92],
    ['clarinetLH2ndFingerClosed', '\uE0A7', 93],
    ['clarinetLHEFlatClosed', '\uE0A8', 94],
    ['clarinetLH3rdFingerClosed', '\uE0A9', 95],
    ['clarinetLHCSharpClosed', '\uE0AA', 96],
    ['clarinetLHFClosed', '\uE0AB', 97],
    ['clarinetLHGSharpAltClosed', '\uE0AC', 98],
    ['clarinetLHEClosed', '\uE0AD', 99],
    ['clarinetRH1stSideClosed', '\uE0AE', 100],
    ['clarinetRH2ndSideClosed', '\uE0AF', 101],
    ['clarinetRH3rdSideClosed', '\uE0B0', 102],
    ['clarinetRH4thSideClosed', '\uE0B1', 103],
    ['clarinetRH1stFingerClosed', '\uE0B2', 104],
    ['clarinetRH2ndFingerClosed', '\uE0B3', 105],
    ['clarinetRHBClosed', '\uE0B4', 106],
    ['clarinetRH3rdFingerClosed', '\uE0B5', 107],
    ['clarinetRHFSharpClosed', '\uE0B6', 108],
    ['clarinetRHGSharpClosed', '\uE0B7', 109],
    ['clarinetRHEClosed', '\uE0B8', 110],
    ['clarinetRHFClosed', '\uE0B9', 111],
    ['clarinetBassEFlatClosed', '\uE0BA', 112],
    ['clarinetLH1stFingerRingOnly', '\uE0BB', 113],
    ['clarinetLH2ndFingerRingOnly', '\uE0BC', 114],
    ['clarinetLH3rdFingerRingOnly', '\uE0BD', 115],
    ['clarinetRH1stFingerRingOnly', '\uE0BE', 116],
    ['clarinetRH2ndFingerRingOnly', '\uE0BF', 117],
    ['clarinetRH3rdFingerRingOnly', '\uE0C0', 118],
    ['clarinetLH1stFingerHalfClosedLeft', '\uE0C1', 119],
    ['clarinetLH2ndFingerHalfClosedLeft', '\uE0C2', 120],
    ['clarinetLH3rdFingerHalfClosedLeft', '\uE0C3', 121],
    ['clarinetRH1stFingerHalfClosedLeft', '\uE0C4', 122],
    ['clarinetRH2ndFingerHalfClosedLeft', '\uE0C5', 123],
    ['clarinetRH3rdFingerHalfClosedLeft', '\uE0C6', 124],
    ['clarinetLH1stFingerHalfClosedRight', '\uE0C7', 125],
    ['clarinetLH2ndFingerHalfClosedRight', '\uE0C8', 126],
    ['clarinetLH3rdFingerHalfClosedRight', '\uE0C9', 127],
    ['clarinetRH1stFingerHalfClosedRight', '\uE0CA', 128],
    ['clarinetRH2ndFingerHalfClosedRight', '\uE0CB', 129],
    ['clarinetRH3rdFingerHalfClosedRight', '\uE0CC', 130],
    ['clarinetLH1stFingerQuarterClosedLeft', '\uE0CD', 131],
    ['clarinetLH2ndFingerQuarterClosedLeft', '\uE0CE', 132],
    ['clarinetLH3rdFingerQuarterClosedLeft', '\uE0CF', 133],
    ['clarinetRH1stFingerQuarterClosedLeft', '\uE0D0', 134],
    ['clarinetRH2ndFingerQuarterClosedLeft', '\uE0D1', 135],
    ['clarinetRH3rdFingerQuarterClosedLeft', '\uE0D2', 136],
    ['clarinetLH1stFingerQuarterClosedRight', '\uE0D3', 137],
    ['clarinetLH2ndFingerQuarterClosedRight', '\uE0D4', 138],
    ['clarinetLH3rdFingerQuarterClosedRight', '\uE0D5', 139],
    ['clarinetRH1stFingerQuarterClosedRight', '\uE0D6', 140],
    ['clarinetRH2ndFingerQuarterClosedRight', '\uE0D7', 141],
    ['clarinetRH3rdFingerQuarterClosedRight', '\uE0D8', 142],
    ['clarinetRegisterTrill', '\uE0D9', 143],
    ['clarinetLHThumbTrill', '\uE0DA', 144],
    ['clarinetLHATrill', '\uE0DB', 145],
    ['clarinetLHGSharpTrill', '\uE0DC', 146],
    ['clarinetLH1stFingerTrill', '\uE0DD', 147],
    ['clarinetLH2ndFingerTrill', '\uE0DE', 148],
    ['clarinetLHEFlatTrill', '\uE0DF', 149],
    ['clarinetLH3rdFingerTrill', '\uE0E0', 150],
    ['clarinetLHCSharpTrill', '\uE0E1', 151],
    ['clarinetLHFTrill', '\uE0E2', 152],
    ['clarinetLHGSharpAltTrill', '\uE0E3', 153],
    ['clarinetLHETrill', '\uE0E4', 154],
    ['clarinetRH1stSideTrill', '\uE0E5', 155],
    ['clarinetRH2ndSideTrill', '\uE0E6', 156],
    ['clarinetRH3rdSideTrill', '\uE0E7', 157],
    ['clarinetRH4thSideTrill', '\uE0E8', 158],
    ['clarinetRH1stFingerTrill', '\uE0E9', 159],
    ['clarinetRH2ndFingerTrill', '\uE0EA', 160],
    ['clarinetRHBTrill', '\uE0EB', 161],
    ['clarinetRH3rdFingerTrill', '\uE0EC', 162],
    ['clarinetRHFSharpTrill', '\uE0ED', 163],
    ['clarinetRHGSharpTrill', '\uE0EE', 164],
    ['clarinetRHETrill', '\uE0EF', 165],
    ['clarinetRHFTrill', '\uE0F0', 166],
    ['clarinetBassEFlatTrill', '\uE0F1', 167],
    ['oboeChart', '\uE140', 168],
    ['oboeLH3rdOctaveClosed', '\uE141', 169],
    ['oboeLH1stOctaveClosed', '\uE142', 170],
    ['oboeLH1stFingerClosed', '\uE143', 171],
    ['oboeLH2ndOctaveClosed', '\uE144', 172],
    ['oboeLHBTrillClosed', '\uE145', 173],
    ['oboeLHDTrillClosed', '\uE146', 174],
    ['oboeLH2ndFingerClosed', '\uE147', 175],
    ['oboeLHCSharpTrillClosed', '\uE148', 176],
    ['oboeLH3rdFingerClosed', '\uE149', 177],
    ['oboeLHGSharpClosed', '\uE14A', 178],
    ['oboeLHLowBClosed', '\uE14B', 179],
    ['oboeLHEFlatClosed', '\uE14C', 180],
    ['oboeLHFClosed', '\uE14D', 181],
    ['oboeLHLowBFlatClosed', '\uE14E', 182],
    ['oboeRHAClosed', '\uE14F', 183],
    ['oboeRHGSharpClosed', '\uE150', 184],
    ['oboeRH1stFingerClosed', '\uE151', 185],
    ['oboeRHDTrillClosed', '\uE152', 186],
    ['oboeRH2ndFingerClosed', '\uE153', 187],
    ['oboeRHFClosed', '\uE154', 188],
    ['oboeRH3rdFingerClosed', '\uE155', 189],
    ['oboeRHCBananaClosed', '\uE156', 190],
    ['oboeRHLowCClosed', '\uE157', 191],
    ['oboeRHLowCSharpClosed', '\uE158', 192],
    ['oboeRHLowEFlatKeyClosed', '\uE159', 193],
    ['oboeLH1stFingerRingOnly', '\uE15A', 194],
    ['oboeLH2ndFingerRingOnly', '\uE15B', 195],
    ['oboeLH3rdFingerRingOnly', '\uE15C', 196],
    ['oboeRH1stFingerRingOnly', '\uE15D', 197],
    ['oboeRH2ndFingerRingOnly', '\uE15E', 198],
    ['oboeRH3rdFingerRingOnly', '\uE15F', 199],
    ['oboeLH1stFingerHalfClosed', '\uE160', 200],
    ['oboeLH2ndFingerHalfClosedLeft', '\uE161', 201],
    ['oboeLH3rdFingerHalfClosedLeft', '\uE162', 202],
    ['oboeRH1stFingerHalfClosedLeft', '\uE163', 203],
    ['oboeRH2ndFingerHalfClosedLeft', '\uE164', 204],
    ['oboeRH3rdFingerHalfClosedLeft', '\uE165', 205],
    ['oboeLH2ndFingerHalfClosedRight', '\uE166', 206],
    ['oboeLH3rdFingerHalfClosedRight', '\uE167', 207],
    ['oboeRH1stFingerHalfClosedRight', '\uE168', 208],
    ['oboeRH2ndFingerHalfClosedRight', '\uE169', 209],
    ['oboeRH3rdFingerHalfClosedRight', '\uE16A', 210],
    ['oboeLH2ndFingerQuarterClosedLeft', '\uE16B', 211],
    ['oboeLH3rdFingerQuarterClosedLeft', '\uE16C', 212],
    ['oboeRH1stFingerQuarterClosedLeft', '\uE16D', 213],
    ['oboeRH2ndFingerQuarterClosedLeft', '\uE16E', 214],
    ['oboeRH3rdFingerQuarterClosedLeft', '\uE16F', 215],
    ['oboeLH2ndFingerQuarterClosedRight', '\uE170', 216],
    ['oboeLH3rdFingerQuarterClosedRight', '\uE171', 217],
    ['oboeRH1stFingerQuarterClosedRight', '\uE172', 218],
    ['oboeRH2ndFingerQuarterClosedRight', '\uE173', 219],
    ['oboeRH3rdFingerQuarterClosedRight', '\uE174', 220],
    ['oboeLH3rdOctaveTrill', '\uE175', 221],
    ['oboeLH1stOctaveTrill', '\uE176', 222],
    ['oboeLH1stFingerTrill', '\uE177', 223],
    ['oboeLH2ndOctaveTrill', '\uE178', 224],
    ['oboeLHBTrillTrill', '\uE179', 225],
    ['oboeLHDTrillTrill', '\uE17A', 226],
    ['oboeLH2ndFingerTrill', '\uE17B', 227],
    ['oboeLHCSharpTrillTrill', '\uE17C', 228],
    ['oboeLH3rdFingerTrill', '\uE17D', 229],
    ['oboeLHGSharpTrill', '\uE17E', 230],
    ['oboeLHLowBTrill', '\uE17F', 231],
    ['oboeLHEFlatTrill', '\uE180', 232],
    ['oboeLHFTrill', '\uE181', 233],
    ['oboeLHLowBFlatTrill', '\uE182', 234],
    ['oboeRHATrill', '\uE183', 235],
    ['oboeRHGSharpTrill', '\uE184', 236],
    ['oboeRH1stFingerTrill', '\uE185', 237],
    ['oboeRHDTrillTrill', '\uE186', 238],
    ['oboeRH2ndFingerTrill', '\uE187', 239],
    ['oboeRHFTrill', '\uE188', 240],
    ['oboeRH3rdFingerTrill', '\uE189', 241],
    ['oboeRHCBananaTrill', '\uE18A', 242],
    ['oboeRHLowCTrill', '\uE18B', 243],
    ['oboeRHLowCSharpTrill', '\uE18C', 244],
    ['oboeRHLowEFlatKeyTrill', '\uE18D', 245],
    ['bassoonChart', '\uE1E0', 246],
    ['bassoonChartThumbsHands', '\uE1E1', 247],
    ['bassoonLHHighEClosed', '\uE1E2', 248],
    ['bassoonLH1stFingerClosed', '\uE1E3', 249],
    ['bassoonLHHighEFlatClosed', '\uE1E4', 250],
    ['bassoonLH2ndFingerClosed', '\uE1E5', 251],
    ['bassoonLH3rdFingerRingClosed', '\uE1E6', 252],
    ['bassoonLH3rdFingerClosed', '\uE1E7', 253],
    ['bassoonLHLowEFlatClosed', '\uE1E8', 254],
    ['bassoonLHLowDFlatClosed', '\uE1E9', 255],
    ['bassoonRHCSharpTrillClosed', '\uE1EA', 256],
    ['bassoonRH1stFingerClosed', '\uE1EB', 257],
    ['bassoonRH2ndFingerRingClosed', '\uE1EC', 258],
    ['bassoonRH2ndFingerClosed', '\uE1ED', 259],
    ['bassoonRHBFlatTrillClosed', '\uE1EE', 260],
    ['bassoonRHLowGClosed', '\uE1EF', 261],
    ['bassoonRHLowFClosed', '\uE1F0', 262],
    ['bassoonRHFSharpClosed', '\uE1F1', 263],
    ['bassoonRHAFlatClosed', '\uE1F2', 264],
    ['bassoonLTHighDClosed', '\uE1F3', 265],
    ['bassoonLTHighBClosed', '\uE1F4', 266],
    ['bassoonLTHighAClosed', '\uE1F5', 267],
    ['bassoonLTCSharpClosed', '\uE1F6', 268],
    ['bassoonLTWhisperKeyClosed', '\uE1F7', 269],
    ['bassoonLTLowBFlatClosed', '\uE1F8', 270],
    ['bassoonLTLowBClosed', '\uE1F9', 271],
    ['bassoonLTLowCClosed', '\uE1FA', 272],
    ['bassoonLTLowDClosed', '\uE1FB', 273],
    ['bassoonRTBFlatClosed', '\uE1FC', 274],
    ['bassoonRTLowEClosed', '\uE1FD', 275],
    ['bassoonRTLowFSharpClosed', '\uE1FE', 276],
    ['bassoonRTAFlatClosed', '\uE1FF', 277],
    ['bassoonLH1stFingerHalfClosed', '\uE200', 278],
    ['bassoonLH2ndFingerHalfClosed', '\uE201', 279],
    ['bassoonLH3rdFingerHalfClosed', '\uE202', 280],
    ['bassoonRH1stFingerHalfClosed', '\uE203', 281],
    ['bassoonRH2ndFingerHalfClosed', '\uE204', 282],
    ['bassoonLH1stFingerQuarterClosed', '\uE205', 283],
    ['bassoonLH2ndFingerQuarterClosed', '\uE206', 284],
    ['bassoonLH3rdFingerQuarterClosed', '\uE207', 285],
    ['bassoonRH1stFingerQuarterClosed', '\uE208', 286],
    ['bassoonRH2ndFingerQuarterClosed', '\uE209', 287],
    ['bassoonLH1stFingerThreeQuartersClosed', '\uE20A', 288],
    ['bassoonLH2ndFingerThreeQuartersClosed', '\uE20B', 289],
    ['bassoonLH3rdFingerThreeQuartersClosed', '\uE20C', 290],
    ['bassoonRH1stFingerThreeQuartersClosed', '\uE20D', 291],
    ['bassoonRH2ndFingerThreeQuartersClosed', '\uE20E', 292],
    ['bassoonLHHighETrill', '\uE20F', 293],
    ['bassoonLH1stFingerTrill', '\uE210', 294],
    ['bassoonLHHighEFlatTrill', '\uE211', 295],
    ['bassoonLH2ndFingerTrill', '\uE212', 296],
    ['bassoonLH3rdFingerRingTrill', '\uE213', 297],
    ['bassoonLHLowEFlatTrill', '\uE214', 298],
    ['bassoonLHLowDFlatTrill', '\uE215', 299],
    ['bassoonRHCSharpTrillTrill', '\uE216', 300],
    ['bassoonRH1stFingerTrill', '\uE217', 301],
    ['bassoonRH2ndFingerTrill', '\uE218', 302],
    ['bassoonRHBFlatTrillTrill', '\uE219', 303],
    ['bassoonRHLowGTrill', '\uE21A', 304],
    ['bassoonRHLowFTrill', '\uE21B', 305],
    ['bassoonRHFSharpTrill', '\uE21C', 306],
    ['bassoonRHAFlatTrill', '\uE21D', 307],
    ['bassoonLTHighDTrill', '\uE21E', 308],
    ['bassoonLTHighBTrill', '\uE21F', 309],
    ['bassoonLTHighATrill', '\uE220', 310],
    ['bassoonLTCSharpTrill', '\uE221', 311],
    ['bassoonLTWhisperKeyTrill', '\uE222', 312],
    ['bassoonLTLowBFlatTrill', '\uE223', 313],
    ['bassoonLTLowBTrill', '\uE224', 314],
    ['bassoonLTLowCTrill', '\uE225', 315],
    ['bassoonLTLowDTrill', '\uE226', 316],
    ['bassoonRTBFlatTrill', '\uE227', 317],
    ['bassoonRTLowETrill', '\uE228', 318],
    ['bassoonRTLowFSharpTrill', '\uE229', 319],
    ['bassoonRTAFlatTrill', '\uE22A', 320],
    ['saxophoneChart', '\uE280', 321],
    ['saxophoneBaritoneLHLowAOpen', '\uE281', 322],
    ['saxophoneLHOctaveClosed', '\uE282', 323],
    ['saxophoneLHFrontFClosed', '\uE283', 324],
    ['saxophoneLH1stFingerClosed', '\uE284', 325],
    ['saxophoneLHBFlatClosed', '\uE285', 326],
    ['saxophoneLH2ndFingerClosed', '\uE286', 327],
    ['saxophoneLH3rdFingerClosed', '\uE287', 328],
    ['saxophoneLHEFlatPalmClosed', '\uE288', 329],
    ['saxophoneLHDPalmClosed', '\uE289', 330],
    ['saxophoneLHFPalmClosed', '\uE28A', 331],
    ['saxophoneLHGSharpClosed', '\uE28B', 332],
    ['saxophoneLHLowCSharpClosed', '\uE28C', 333],
    ['saxophoneLHLowBClosed', '\uE28D', 334],
    ['saxophoneLHLowBFlatClosed', '\uE28E', 335],
    ['saxophoneRHESideClosed', '\uE28F', 336],
    ['saxophoneRHCSideClosed', '\uE290', 337],
    ['saxophoneRHBFlatSideClosed', '\uE291', 338],
    ['saxophoneRHHighFSharpClosed', '\uE292', 339],
    ['saxophoneRH1stFingerClosed', '\uE293', 340],
    ['saxophoneRH2ndFingerClosed', '\uE294', 341],
    ['saxophoneRHFSharpAlternateClosed', '\uE295', 342],
    ['saxophoneRH3rdFingerClosed', '\uE296', 343],
    ['saxophoneRHLowEFlatClosed', '\uE297', 344],
    ['saxophoneRHLowCClosed', '\uE298', 345],
    ['saxophoneBaritoneLHLowAClosed', '\uE299', 346],
    ['saxophoneLH1stFingerHalfClosed', '\uE29A', 347],
    ['saxophoneLH2ndFingerHalfClosed', '\uE29B', 348],
    ['saxophoneLH3rdFingerHalfClosed', '\uE29C', 349],
    ['saxophoneRH1stFingerHalfClosed', '\uE29D', 350],
    ['saxophoneRH2ndFingerHalfClosed', '\uE29E', 351],
    ['saxophoneRH3rdFingerHalfClosed', '\uE29F', 352],
    ['saxophoneLHOctaveTrill', '\uE2A0', 353],
    ['saxophoneLHFrontFTrill', '\uE2A1', 354],
    ['saxophoneLH1stFingerTrill', '\uE2A2', 355],
    ['saxophoneLHBFlatTrill', '\uE2A3', 356],
    ['saxophoneLH2ndFingerTrill', '\uE2A4', 357],
    ['saxophoneLH3rdFingerTrill', '\uE2A5', 358],
    ['saxophoneLHEFlatPalmTrill', '\uE2A6', 359],
    ['saxophoneLHDPalmTrill', '\uE2A7', 360],
    ['saxophoneLHFPalmTrill', '\uE2A8', 361],
    ['saxophoneLHGSharpTrill', '\uE2A9', 362],
    ['saxophoneLHLowCSharpTrill', '\uE2AA', 363],
    ['saxophoneLHLowBTrill', '\uE2AB', 364],
    ['saxophoneLHLowBFlatTrill', '\uE2AC', 365],
    ['saxophoneRHESideTrill', '\uE2AD', 366],
    ['saxophoneRHCSideTrill', '\uE2AE', 367],
    ['saxophoneRHBFlatSideTrill', '\uE2AF', 368],
    ['saxophoneRHHighFSharpTrill', '\uE2B0', 369],
    ['saxophoneRH1stFingerTrill', '\uE2B1', 370],
    ['saxophoneRH2ndFingerTrill', '\uE2B2', 371],
    ['saxophoneRHFSharpAlternateTrill', '\uE2B3', 372],
    ['saxophoneRH3rdFingerTrill', '\uE2B4', 373],
    ['saxophoneRHLowEFlatTrill', '\uE2B5', 374],
    ['saxophoneRHLowCTrill', '\uE2B6', 375],
    ['saxophoneBaritoneLHLowATrill', '\uE2B7', 376],
    ['recorderChart', '\uE320', 377],
    ['recorderLHThumbClosed', '\uE321', 378],
    ['recorderLH1stFingerClosed', '\uE322', 379],
    ['recorderLH2ndFingerClosed', '\uE323', 380],
    ['recorderLH3rdFingerClosed', '\uE324', 381],
    ['recorderRH1stFingerClosed', '\uE325', 382],
    ['recorderRH2ndFingerClosed', '\uE326', 383],
    ['recorderRH1stDoubleHoleLeftClosed', '\uE327', 384],
    ['recorderRH1stDoubleHoleRightClosed', '\uE328', 385],
    ['recorderRH2ndDoubleHoleLeftClosed', '\uE329', 386],
    ['recorderRH2ndDoubleHoleRightClosed', '\uE32A', 387],
    ['recorderBellKeyClosed', '\uE32B', 388],
    ['recorderLHThumbHalfClosedLeft', '\uE32C', 389],
    ['recorderLH1stFingerHalfClosedLeft', '\uE32D', 390],
    ['recorderLH2ndFingerHalfClosedLeft', '\uE32E', 391],
    ['recorderLH3rdFingerHalfClosedLeft', '\uE32F', 392],
    ['recorderRH1stFingerHalfClosedLeft', '\uE330', 393],
    ['recorderRH2ndFingerHalfClosedLeft', '\uE331', 394],
    ['recorderRH1stDoubleHoleLeftHalfClosedLeft', '\uE332', 395],
    ['recorderRH1stDoubleHoleRightHalfClosedLeft', '\uE333', 396],
    ['recorderRH2ndDoubleHoleLeftHalfClosedLeft', '\uE334', 397],
    ['recorderRH2ndDoubleHoleRightHalfClosedLeft', '\uE335', 398],
    ['recorderLHThumbHalfClosedRight', '\uE336', 399],
    ['recorderLH1stFingerHalfClosedRight', '\uE337', 400],
    ['recorderLH2ndFingerHalfClosedRight', '\uE338', 401],
    ['recorderLH3rdFingerHalfClosedRight', '\uE339', 402],
    ['recorderRH1stFingerHalfClosedRight', '\uE33A', 403],
    ['recorderRH2ndFingerHalfClosedRight', '\uE33B', 404],
    ['recorderRH1stDoubleHoleLeftHalfClosedRight', '\uE33C', 405],
    ['recorderRH1stDoubleHoleRightHalfClosedRight', '\uE33D', 406],
    ['recorderRH2ndDoubleHoleLeftHalfClosedRight', '\uE33E', 407],
    ['recorderRH2ndDoubleHoleRightHalfClosedRight', '\uE33F', 408],
    ['recorderLHThumbQuarterClosedLeft', '\uE340', 409],
    ['recorderLH1stFingerQuarterClosedLeft', '\uE341', 410],
    ['recorderLH2ndFingerQuarterClosedLeft', '\uE342', 411],
    ['recorderLH3rdFingerQuarterClosedLeft', '\uE343', 412],
    ['recorderRH1stFingerQuarterClosedLeft', '\uE344', 413],
    ['recorderRH2ndFingerQuarterClosedLeft', '\uE345', 414],
    ['recorderRH1stDoubleHoleLeftQuarterClosedLeft', '\uE346', 415],
    ['recorderRH1stDoubleHoleRightQuarterClosedLeft', '\uE347', 416],
    ['recorderRH2ndDoubleHoleLeftQuarterClosedLeft', '\uE348', 417],
    ['recorderRH2ndDoubleHoleRightQuarterClosedLeft', '\uE349', 418],
    ['recorderLHThumbQuarterClosedRight', '\uE34A', 419],
    ['recorderLH1stFingerQuarterClosedRight', '\uE34B', 420],
    ['recorderLH2ndFingerQuarterClosedRight', '\uE34C', 421],
    ['recorderLH3rdFingerQuarterClosedRight', '\uE34D', 422],
    ['recorderRH1stFingerQuarterClosedRight', '\uE34E', 423],
    ['recorderRH2ndFingerQuarterClosedRight', '\uE34F', 424],
    ['recorderRH1stDoubleHoleLeftQuarterClosedRight', '\uE350', 425],
    ['recorderRH1stDoubleHoleRightQuarterClosedRight', '\uE351', 426],
    ['recorderRH2ndDoubleHoleLeftQuarterClosedRight', '\uE352', 427],
    ['recorderRH2ndDoubleHoleRightQuarterClosedRight', '\uE353', 428],
    ['recorderLHThumbTrill', '\uE354', 429],
    ['recorderLH1stFingerTrill', '\uE355', 430],
    ['recorderLH2ndFingerTrill', '\uE356', 431],
    ['recorderLH3rdFingerTrill', '\uE357', 432],
    ['recorderRH1stFingerTrill', '\uE358', 433],
    ['recorderRH2ndFingerTrill', '\uE359', 434],
    ['recorderRH1stDoubleHoleLeftTrill', '\uE35A', 435],
    ['recorderRH1stDoubleHoleRightTrill', '\uE35B', 436],
    ['recorderRH2ndDoubleHoleLeftTrill', '\uE35C', 437],
    ['recorderRH2ndDoubleHoleRightTrill', '\uE35D', 438],
    ['woodwindChart', '\uE3C0', 439],
    ['woodwindLH1stFingerHigher', '\uE3C1', 440],
    ['woodwindLHThumbHigher', '\uE3C2', 441],
    ['woodwindLH1stFinger', '\uE3C3', 442],
    ['woodwindLHThumb', '\uE3C4', 443],
    ['woodwindRHThumb', '\uE3C5', 444],
    ['woodwindRH3rdFinger', '\uE3C6', 445],
    ['woodwindRH4thFinger', '\uE3C7', 446],
    ['woodwindLH1stFingerHigherClosed', '\uE3CD', 447],
    ['woodwindLHThumbHigherClosed', '\uE3CE', 448],
    ['woodwindLH1stFingerClosed', '\uE3CF', 449],
    ['woodwindLHThumbClosed', '\uE3D0', 450],
    ['woodwindLH2ndFingerClosed', '\uE3D1', 451],
    ['woodwindLH3rdFingerClosed', '\uE3D2', 452],
    ['woodwindRH1stFingerClosed', '\uE3D3', 453],
    ['woodwindRHThumbClosed', '\uE3D4', 454],
    ['woodwindRH2ndFingerClosed', '\uE3D5', 455],
    ['woodwindRH3rdFingerClosed', '\uE3D6', 456],
    ['woodwindRH4thFingerClosed', '\uE3D7', 457],
    ['woodwindLH1stFingerHigherHalfClosedLeft', '\uE3DD', 458],
    ['woodwindLHThumbHigherHalfClosedLeft', '\uE3DE', 459],
    ['woodwindLH1stFingerHalfClosedLeft', '\uE3DF', 460],
    ['woodwindLHThumbHalfClosedLeft', '\uE3E0', 461],
    ['woodwindLH2ndFingerHalfClosedLeft', '\uE3E1', 462],
    ['woodwindLH3rdFingerHalfClosedLeft', '\uE3E2', 463],
    ['woodwindRH1stFingerHalfClosedLeft', '\uE3E3', 464],
    ['woodwindRHThumbHalfClosedLeft', '\uE3E4', 465],
    ['woodwindRH2ndFingerHalfClosedLeft', '\uE3E5', 466],
    ['woodwindRH3rdFingerHalfClosedLeft', '\uE3E6', 467],
    ['woodwindRH4thFingerHalfClosedLeft', '\uE3E7', 468],
    ['woodwindLH1stFingerHigherHalfClosedRight', '\uE3ED', 469],
    ['woodwindLHThumbHigherHalfClosedRight', '\uE3EE', 470],
    ['woodwindLH1stFingerHalfClosedRight', '\uE3EF', 471],
    ['woodwindLHThumbHalfClosedRight', '\uE3F0', 472],
    ['woodwindLH2ndFingerHalfClosedRight', '\uE3F1', 473],
    ['woodwindLH3rdFingerHalfClosedRight', '\uE3F2', 474],
    ['woodwindRH1stFingerHalfClosedRight', '\uE3F3', 475],
    ['woodwindRHThumbHalfClosedRight', '\uE3F4', 476],
    ['woodwindRH2ndFingerHalfClosedRight', '\uE3F5', 477],
    ['woodwindRH3rdFingerHalfClosedRight', '\uE3F6', 478],
    ['woodwindRH4thFingerHalfClosedRight', '\uE3F7', 479],
    ['woodwindLH1stFingerHigherQuarterClosedLeft', '\uE3FD', 480],
    ['woodwindLHThumbHigherQuarterClosedLeft', '\uE3FE', 481],
    ['woodwindLH1stFingerQuarterClosedLeft', '\uE3FF', 482],
    ['woodwindLHThumbQuarterClosedLeft', '\uE400', 483],
    ['woodwindLH2ndFingerQuarterClosedLeft', '\uE401', 484],
    ['woodwindLH3rdFingerQuarterClosedLeft', '\uE402', 485],
    ['woodwindRH1stFingerQuarterClosedLeft', '\uE403', 486],
    ['woodwindRHThumbQuarterClosedLeft', '\uE404', 487],
    ['woodwindRH2ndFingerQuarterClosedLeft', '\uE405', 488],
    ['woodwindRH3rdFingerQuarterClosedLeft', '\uE406', 489],
    ['woodwindRH4thFingerQuarterClosedLeft', '\uE407', 490],
    ['woodwindLH1stFingerHigherQuarterClosedRight', '\uE40D', 491],
    ['woodwindLHThumbHigherQuarterClosedRight', '\uE40E', 492],
    ['woodwindLH1stFingerQuarterClosedRight', '\uE40F', 493],
    ['woodwindLHThumbQuarterClosedRight', '\uE410', 494],
    ['woodwindLH2ndFingerQuarterClosedRight', '\uE411', 495],
    ['woodwindLH3rdFingerQuarterClosedRight', '\uE412', 496],
    ['woodwindRH1stFingerQuarterClosedRight', '\uE413', 497],
    ['woodwindRHThumbQuarterClosedRight', '\uE414', 498],
    ['woodwindRH2ndFingerQuarterClosedRight', '\uE415', 499],
    ['woodwindRH3rdFingerQuarterClosedRight', '\uE416', 500],
    ['woodwindRH4thFingerQuarterClosedRight', '\uE417', 501],
    ['woodwindLH1stFingerHigherShaded', '\uE41D', 502],
    ['woodwindLHThumbHigherShaded', '\uE41E', 503],
    ['woodwindLH1stFingerShaded', '\uE41F', 504],
    ['woodwindLHThumbShaded', '\uE420', 505],
    ['woodwindLH2ndFingerShaded', '\uE421', 506],
    ['woodwindLH3rdFingerShaded', '\uE422', 507],
    ['woodwindRH1stFingerShaded', '\uE423', 508],
    ['woodwindRHThumbShaded', '\uE424', 509],
    ['woodwindRH2ndFingerShaded', '\uE425', 510],
    ['woodwindRH3rdFingerShaded', '\uE426', 511],
    ['woodwindRH4thFingerShaded', '\uE427', 512],
    ['woodwindLH1stFingerHigherTrill', '\uE42D', 513],
    ['woodwindLHThumbHigherTrill', '\uE42E', 514],
    ['woodwindLH1stFingerTrill', '\uE42F', 515],
    ['woodwindLHThumbTrill', '\uE430', 516],
    ['woodwindLH2ndFingerTrill', '\uE431', 517],
    ['woodwindLH3rdFingerTrill', '\uE432', 518],
    ['woodwindRH1stFingerTrill', '\uE433', 519],
    ['woodwindRHThumbTrill', '\uE434', 520],
    ['woodwindRH2ndFingerTrill', '\uE435', 521],
    ['woodwindRH3rdFingerTrill', '\uE436', 522],
    ['woodwindRH4thFingerTrill', '\uE437', 523],
    ['woodwindOverblownOctave1', '\uE43D', 524],
    ['woodwindOverblownOctave2', '\uE43E', 525],
    ['woodwindHigherOvertoneOctave', '\uE43F', 526],
];